<template>
    <!-- <img :src="commonStore.getImgUrl('shared', 'starGroupIconPurpleRight', 'svg')" /> -->
    <div
        class="outer-container font-jost"
        :style="{
            backgroundImage: `url(${commonStore.getImgUrl(
                'shared',
                'starGroupIconBrownRight',
                'svg'
            )})`,
        }"
    >
        <div class="login-container">
            <p class="login-label mb-2 text-3xl"><b>Login</b></p>
            <span v-if="showErrorMsg" class="text-xl" style="color: red; text-align: left;">invalid ID or password</span>
            <div style="display: flex; flex-direction: column">
                <input
                    type="text"
                    class="form-control mb-5 rounded-xl mt-4"
                    placeholder="Customer ID"
                >
                <input
                    type="password"
                    class="form-control mb-5 rounded-xl"
                    placeholder="Password"
                >
                <button
                    type="button"
                    class="submit-button relative block w-40 rounded-3xl border py-1 text-lg"
                    @click="submit"
                >
                    <span>Submit</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useHeaderStore } from "@/stores/header";
import { useCommonStore } from "@/stores/common";

import { useI18n } from "vue-i18n";

const commonStore = useCommonStore();
const headerStore = useHeaderStore();
const { t, locale } = useI18n();
const router = useRouter();
const showErrorMsg = ref(false);

onMounted(async () => {
});

const routeTo = (position) => {
    router.push({ name: position, params: { uid: "lczmx" } });
};

const submit = () => {
    showErrorMsg.value = true;
};
</script>

<style>
.outer-container {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    margin-top: 5%;
    margin-bottom: 5%;
    background-repeat: no-repeat;
    background-position-x: 100%;
    background-size: 10%;
}

.login-container {
    display: flex;
    flex-direction: column;
    text-align: center;
    background-color: #f5f5f5;
    border-radius: 1vw;
    padding: 1.5vw;
    width: 30%;
}

.form-control {
    border: 0.1vw solid #949494;
    padding-left: 3%;
}

.login-label {
    color: #4e4e4e;
    text-align: left;
}

.submit-button {
    background-color: rgb(96, 56, 19);
    color: rgb(255, 255, 255);
    border: 0.2vw solid transparent;
    text-align: center;
    align-self: center;
}

.forgot-password {
    text-decoration: underline;
    color: #a4a4a4;
    flex-shrink: 0;
    align-self: center;
}

.background-image {
    background-position-x: 50%;
}

input:focus {
    outline: none !important;
    border: 0.05vw solid #4e4e4e;
    box-shadow: 0 0 0.5vw #8f8248;
}

.form-control::placeholder {
  font-family: "jost"; /* Change the font family */
  color: #A4A4A4; /* Change the color of the placeholder text */
  opacity: 40%;
}

</style>
